import SaveDashboard from '@/assets/icons/SaveDashboard';
import { DrawerFooter } from '@/shared/ui/overlays/Drawer/Footer';
import Button from '@/shared/ui/primitives/Button';

export const DrawerFooterButtons = ({
  onSave,
  onDiscard,
  disabled
}: {
  onSave: () => void;
  onDiscard: () => void;
  disabled: boolean;
}) => (
  <DrawerFooter>
    <Button
      disabled={disabled}
      sx={{
        color: 'gx.highlight',
        borderColor: 'gx.highlight',
        height: '48px',
        '&.Mui-disabled': {
          opacity: 1,
          borderColor: 'gx.neutral'
        }
      }}
      variant='outlined'
      onClick={onDiscard}
    >
      Discard
    </Button>
    <Button
      disabled={disabled}
      startIcon={<SaveDashboard sx={{ fontSize: '24px !important' }} />}
      sx={{
        height: '48px',
        '&.Mui-disabled': {
          opacity: 1,
          backgroundColor: 'gx.neutral',
          borderColor: 'gx.neutral'
        }
      }}
      onClick={onSave}
    >
      Save
    </Button>
  </DrawerFooter>
);
